import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TipoRecurso } from '../models/notice.model';
import { PageResponse, StatusCount } from './pagination.types';

@Injectable({
  providedIn: 'root'
})
export class TipoRecursoService {
  private apiUrl = `${environment.apiUrl}/admin/tipos-recursos`;

  constructor(private http: HttpClient) {}

  getAll(apenasAtivos: boolean = false): Observable<TipoRecurso[]> {
    let params = new HttpParams();
    if (apenasAtivos) {
      params = params.set('apenasAtivos', 'true');
    }
    return this.http.get<TipoRecurso[]>(this.apiUrl, { params });
  }

  getById(id: number): Observable<TipoRecurso> {
    return this.http.get<TipoRecurso>(`${this.apiUrl}/${id}`);
  }

  create(resourceType: TipoRecurso): Observable<TipoRecurso> {
    return this.http.post<TipoRecurso>(this.apiUrl, resourceType);
  }

  update(id: number, resourceType: TipoRecurso): Observable<TipoRecurso> {
    return this.http.put<TipoRecurso>(`${this.apiUrl}/${id}`, resourceType);
  }
  
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  toggleStatus(id: number, ativo: boolean): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/${id}/toggle-status`, { ativo });
  }

  /**
   * Lista tipos de recursos paginados
   * GET /api/admin/tipos-recursos/paginado
   */
  listarPaginado(
    page: number = 0,
    size: number = 10,
    sortBy: string = 'nome',
    sortDirection: 'ASC' | 'DESC' = 'ASC',
    apenasAtivos?: boolean
  ): Observable<PageResponse<TipoRecurso>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortBy', sortBy)
      .set('sortDirection', sortDirection);
    
    if (apenasAtivos !== undefined) {
      params = params.set('apenasAtivos', apenasAtivos.toString());
    }
    
    return this.http.get<PageResponse<TipoRecurso>>(`${this.apiUrl}/paginado`, { params });
  }

  /**
   * Obtém contagem de status dos tipos de recursos
   * GET /api/admin/tipos-recursos/status
   */
  getStatus(): Observable<StatusCount> {
    return this.http.get<StatusCount>(`${this.apiUrl}/status`);
  }
}